//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import { QDialog } from "quasar";
import { mapState } from "vuex";
import PhotoCapture from "./photo-component.vue";
import VideoCapture from "./video-component.vue";
import PhotoMobile from "./photo-mobile-component.vue";
import VideoMobile from "./video-mobile-component.vue";

const streams = [];

export default {
    name: "MediaRecorder",
    components: {
        PhotoCapture,
        VideoCapture,
        PhotoMobile,
        VideoMobile,
        QDialog,
        AQModal,
        AQDialog

    },
    props: {
        video: { type: Boolean, default: false },
        media: { type: Boolean, default: false },
        timeVideo: { type: Number, default: 10 },
        captureName: { type: String, default: "" },
        range: { type: Object, default: () => {} }

    },

    data() {
        return {
            imageBase64: null,
            videoUrl: null,
            objectToUpload: null,
            modalPosition: "top",
            dataToUpload: null,
            openDialog: false,
            titleDialog: this.$t("capturePhotoVideo.titleDialog"),
            messageTitle: this.$t("capturePhotoVideo.messageDialog"),
            isDisabled: true,
            showMedia: false,
            allowCamera: false,
            foundCamera: false,
            modalSize: "",
            devices: null
        };
    },

    computed: {
        ...mapState("components", ["isSmallScreen"]),
        saveMedia() {
            return { label: this.$t("capturePhotoVideo.doneBtn"), disabled: this.isDisabled };
        },
        title() {
            return this.video ? this.$t("capturePhotoVideo.videoModal") : this.$t("capturePhotoVideo.photoModal");
        }
    },
    watch: {
        media: {
            handler(newValue) {
                this.showMedia = newValue;
                if (this.video) {
                    this.showVideo = newValue;
                } else {
                    this.showPicture = newValue;
                }
            }
        },
        closeCamera: {
            handler(newValue) {
                this.closePhoto = newValue;
            }
        }
    },
    mounted() {
        window.onorientationchange = () => {
            streams.forEach(stream => {
                if (stream.active) {
                    stream.getVideoTracks().forEach(track => track.stop());
                }
            });
        };

        if (this.isSmallScreen || window.matchMedia("(orientation: portrait)").matches) {
            this.checkCamera();
        }
    },
    methods: {
        onStreamAdded(stream) {
            streams.push(stream);
        },
        onVideoResult(data) {
            if (data) {
                const videoFile = this.newVideoUpload(data);
                this.objectToUpload = { type: "video", data: videoFile };
                this.isDisabled = false;
            }
        },
        recordingStarted() {
            if (!this.isDisabled) {
                this.isDisabled = true;
            }
        },
        cameraIsUsed(data) {
            this.foundCamera = !data;
        },
        newVideoUpload(data) {
            return new File([data], `${this.captureName}.webm`, { type: "video/webm" });
        },
        reset() {
            this.isDisabled = true;
            this.imageBase64 = null;
        },
        modifyImage(data) {
            if (data) {
                fetch(data)
                    .then(res => res.blob())
                    .then(blob => {
                        const file = new File([blob], `${this.captureName}.png`, { type: "image/png" });
                        this.objectToUpload = { type: "photo", data: file };
                        this.isDisabled = false;
                    });
            }
        },
        mediaAction($event) {
            if ($event === "primary") {
                this.saveData();
            } else if ($event === "close") {
                this.closeModal();
            }
        },
        saveData() {
            this.showMedia = false;
            this.$emit("uploadFile", this.objectToUpload);
            this.closeCamera();
            this.$emit("cancelMedia", false);
        },
        closeModal() {
            if ((this.foundCamera && this.allowCamera) || this.checkRefs()) {
                this.openDialog = true;
            } else {
                this.closeCamera();
                this.showMedia = false;
                this.$emit("cancelMedia", false);
            }
        },
        checkRefs() {
            let fromLandscape = false;
            if (this.$refs && (this.$refs.photoMobile || this.$refs.videoMobile)) {
                fromLandscape = true;
            }
            return fromLandscape;
        },
        okAction() {
            this.showMedia = false;
            this.openDialog = false;
            this.closeCamera();
            this.$emit("cancelMedia", this.openDialog);
        },
        closeCamera() {
            if (this.isSmallScreen || window.matchMedia("(orientation: portrait)").matches) {
                if (this.video) {
                    this.$refs.videoMobile.stopVideo();
                } else {
                    this.$refs.photoMobile.stopVideoStream();
                }
            } else if (this.video) {
                this.$refs.video.stopVideo();
            } else {
                this.$refs.photo.stopVideoStream();
            }
            this.stopVideo();
        },
        cancelAction() {
            this.openDialog = false;
        },
        checkCamera() {
            const md = navigator.mediaDevices;
            streams.splice(0, streams.length);
            this.isDisabled = true;
            if (md && md.enumerateDevices) {
                md.enumerateDevices().then(devices => {
                    this.devices = devices.filter(device => device.kind === "videoinput");
                    this.foundCamera = !!this.devices;
                    if (this.foundCamera) {
                        if (!this.isSmallScreen && !window.matchMedia("(orientation: portrait)").matches) {
                            navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
                                streams.push(stream);
                            });
                        }
                        this.allowCamera = true;
                    }
                });
            }
        },
        stopVideo() {
            streams.forEach(stream => {
                if (stream.active) {
                    stream.getVideoTracks().forEach(track => track.stop());
                }
            });
        },
        // mobile actions
        closeMobileDialog() {
            this.closeModal();
        },
        submitData() {
            this.saveData();
        }
    }
};
